(window as any).pdfWorkerSrc = '/assets/scripts/pdf.worker.min.js';
(window as any)['pdfWorkerSrc4.8.69'] = '/assets/scripts/pdf.worker.min.js';

import { GlobalWorkerOptions } from 'pdfjs-dist';
GlobalWorkerOptions.workerSrc = '/assets/scripts/pdf.worker.min.js';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.log(err));
